import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Organized%20modern%20desk%20workspace%20with%20open%20laptop%20showing%20colorful%20spreadsheet%20data%2C%20coffee%20cup%20and%20notebook%20beside%20keyboard%2C%20bright%20natural%20window%20light%2C%20green%20potted%20plants%20on%20wooden%20desk%2C%20productive%20creative%20atmosphere%2C%20warm%20morning%20sunlight%20casting%20gentle%20shadows%2C%20contemporary%20home%20office%20with%20art%20prints%20on%20wall%2C%20lifestyle%20productivity%20photography%2C%20clean%20airy%20composition%20with%20inspiring%20energy&width=1600&height=900&seq=hero-main-v2-2026&orientation=landscape"
          alt="Superbuy Spreadsheet organized shopping research workspace"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 py-20 md:py-28">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20">
            <div className="lg:w-[55%]">
              <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/90 text-foreground-700 text-xs font-medium mb-8 whitespace-nowrap">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                Independent Educational Resource
              </span>

              <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-[1.08] mb-6">
                Superbuy Spreadsheet
                <br />
                <span className="text-background-50/80">The Ultimate Resource</span>
                <br />
                <span className="text-accent-300">For Smarter Shopping</span>
              </h1>
            </div>

            <div className="lg:w-[45%] lg:pt-4">
              <p className="text-background-50/85 text-base md:text-lg leading-relaxed mb-8 max-w-md">
                Superbuy Spreadsheet Hub is an independent educational platform helping shoppers organize product research, compare options, and make smarter purchasing decisions with curated guides and category resources.
              </p>

              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  onClick={() => navigate('/article/superbuy-spreadsheet-guide')}
                  className="px-7 py-3.5 rounded-full bg-primary-800 text-background-50 text-sm font-semibold hover:bg-primary-900 transition-colors duration-200 cursor-pointer whitespace-nowrap text-center"
                >
                  Explore Superbuy Spreadsheet
                </button>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-7 py-3.5 rounded-full border-2 border-background-50/60 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors duration-200 cursor-pointer whitespace-nowrap text-center"
                >
                  Visit Main Website
                </a>
              </div>

              <div className="flex flex-wrap gap-4 mt-6">
                <span className="flex items-center gap-1.5 text-background-50/70 text-xs">
                  <i className="ri-check-line text-accent-400"></i> Updated Resources
                </span>
                <span className="flex items-center gap-1.5 text-background-50/70 text-xs">
                  <i className="ri-check-line text-accent-400"></i> Beginner Friendly
                </span>
                <span className="flex items-center gap-1.5 text-background-50/70 text-xs">
                  <i className="ri-check-line text-accent-400"></i> Comparison Guides
                </span>
                <span className="flex items-center gap-1.5 text-background-50/70 text-xs">
                  <i className="ri-check-line text-accent-400"></i> Safety Information
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}